import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function STHowItWorks() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-2025">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2026">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-2027">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-2028">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-2029">
              <img src="https://cdn.magicpatterns.com/uploads/9CwbM3vQd29QpSnVvkWtZj/skintyte-bbl.jpg" alt="SkinTyte BBL Treatment" className="w-full h-full object-cover" data-id="element-2030" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2031">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-2032">
              HOW DOES BBL WORK?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-2033"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body" data-id="element-2034">
              <p data-id="element-2035">
                SkinTyte utilizes broadband light technology (BBL) that deeply
                heats the deep layers of the skin, while cooling the surface
                layer. The process initiates the body's natural healing process
                to create a new collagen foundation. The fresh collagen makes
                the skin appear tight, plump and youthful for up to 12 months.
              </p>
              <p data-id="element-2036">
                BBL is based on the principle of selective photothermolysis.
                This involves targeting specific tissues with light energy to
                achieve desired therapeutic effects while minimizing damage to
                surrounding tissues. The term combines "selective," meaning the
                ability to choose or target specific tissues, "photo," referring
                to light, and "thermolysis," which is the process of breaking
                down molecules with heat.
              </p>
              <p data-id="element-2037">
                At Be CLINICAL, we love SkinTyte technology because it allows us
                to select the appropriate wavelength of light and pulse
                duration, to deliver a fully customized treatment for each
                patient's specific concerns and target areas.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}